export const REQUEST_STATUS = {
    IDLE: "idle",
    IN_PROGRESS: "in-progress",
    DATA_RECEIVED: "data-received",
    SUCCESS: "success",
    ERROR: "error",
  };
/*
 * Possible status strings for any kind of application
 */
export const APPLICATION_STATUS_PENDING_PAYMENT =
  "PENDING_PAYMENT"; /* default */
export const APPLICATION_STATUS_PENDING = "PENDING";
export const APPLICATION_STATUS_OPENED = "OPENED";
export const APPLICATION_STATUS_PENDING_AGENCY = "PENDING_AGENCY_LICENCE";
export const APPLICATION_RENEWAL_STATUS_PENDING = "RENEWAL_PENDING";
export const APPLICATION_STATUS_SUBMITTED = "SUBMITTED";
export const APPLICATION_RENEWAL_STATUS_SUBMITTED = "RENEWAL_SUBMITTED";
export const APPLICATION_STATUS_APPROVED_ISSUED = "APPROVED";
export const APPLICATION_STATUS_DENIED = "DENIED";
export const APPLICATION_STATUS_CANCELLED = "CANCELLED";
export const APPLICATION_STATUS_UNREAD = "UNREAD";
export const APPLICATION_STATUS_UNDER_REVIEW = "UNDER_REVIEW";
export const APPLICATION_STATUS_ACTION_REQUIRED = "ACTION_REQUIRED";
export const APPLICATION_STATUS_WITHDRAWN_BY_CLIENT = "WITHDRAWN_BY_CLIENT";
export const APPLICATION_STATUS_WITHDRAWN_APPROVED = "WITHDRAWN_APPROVED";
/*
 * Possible licence status for any kind of licences
 */
export const LICENCE_STATUS_NEW = "NEW"; /* default */
export const LICENCE_STATUS_ACTIVE = "ACTIVE";
export const LICENCE_STATUS_REVOKED = "REVOKED";
export const LICENCE_STATUS_SUSPENDED = "SUSPENDED";
export const LICENCE_STATUS_WITHDRAWN = "WITHDRAWN";
export const LICENCE_STATUS_EXPIRED = "EXPIRED";
export const LICENCE_STATUS_WITHDRAWN_BY_CLIENT = "WITHDRAWN_BY_CLIENT"
/*
 * Possible values of surety bond delivery
 */
export const SURETYBOND_STATUS_NONE = "NONE"; /* default */
export const SURETYBOND_STATUS_NOTRECEIVED = "NOT_RECEIVED";
export const SURETYBOND_STATUS_RECEIVED = "RECEIVED";
/*
 *
 */
export const PAYMENT_STATUS_NONE = "NONE";
export const PAYMENT_STATUS_INPROGRESS = "IN-PROGRESS";
export const PAYMENT_STATUS_SUCCESS = "SUCCESS";
export const PAYMENT_STATUS_FAILURE = "FAILURE";

export const CHANGE_REQUEST_TYPE_MAIN_AGENT = "CHANGE_REQUEST_TYPE_MAIN_AGENT";
export const CHANGE_REQUEST_STATUS_PENDING = "CHANGE_REQUEST_STATUS_PENDING";
export const CHANGE_REQUEST_STATUS_SUBMITTED = "CHANGE_REQUEST_STATUS_SUBMITTED";
export const CHANGE_REQUEST_STATUS_REVIEW = "CHANGE_REQUEST_STATUS_REVIEW";
export const CHANGE_REQUEST_STATUS_REVIEW_COMPLETE = "CHANGE_REQUEST_STATUS_REVIEW_COMPLETE";